import React from "react";
import { Link } from "react-router-dom";
import { useLang } from "@/i18n/LanguageContext";
import { Sparkles, MapPin, Star, HandHeart, ArrowRight } from "lucide-react";

const WA_BADAL = "https://wa.me/6282114294101?text=Assalamualaikum%2C%20saya%20ingin%20info%20layanan%20Badal%20Umroh%20%2F%20Haji%20BATIK%20Travel%20Bekasi.";
const WA_PRIVATE = "https://wa.me/6282114294101?text=Assalamualaikum%2C%20saya%20ingin%20info%20paket%20Umroh%20Private%20BATIK%20Travel%20Bekasi.";

const CATEGORIES = [
  {
    key: "umroh",
    Icon: Sparkles,
    color: "bg-emerald-50 text-emerald-700",
    id: "Paket Umroh",
    en: "Umrah Packages",
    desc_id: "Silver, Gold, Platinum, Titanium & Umroh Plus dari Jakarta.",
    desc_en: "Silver, Gold, Platinum, Titanium & Umrah Plus from Jakarta.",
    href: "/packages",
    external: false,
    cta_id: "Lihat Paket",
    cta_en: "View Packages",
  },
  {
    key: "haji-plus",
    Icon: Star,
    color: "bg-amber-50 text-amber-700",
    id: "Paket Haji Khusus",
    en: "Hajj Plus Package",
    desc_id: "Haji Plus kuota Kemenag — hotel Maktab dekat Jamarat.",
    desc_en: "Hajj Plus with Kemenag quota — Maktab hotel near Jamarat.",
    href: "/packages?tab=haji",
    external: false,
    cta_id: "Lihat Detail",
    cta_en: "View Details",
  },
  {
    key: "haji-furoda",
    Icon: MapPin,
    color: "bg-purple-50 text-purple-700",
    id: "Paket Haji Furoda",
    en: "Furoda Hajj",
    desc_id: "Visa furoda — berangkat tahun ini tanpa antri kuota.",
    desc_en: "Furoda visa — depart this year, no quota waiting list.",
    href: "/packages?tab=haji",
    external: false,
    cta_id: "Lihat Detail",
    cta_en: "View Details",
  },
  {
    key: "badal",
    Icon: HandHeart,
    color: "bg-rose-50 text-rose-700",
    id: "Badal Umroh & Haji",
    en: "Badal Umrah & Hajj",
    desc_id: "Umroh/Haji atas nama keluarga yang telah wafat.",
    desc_en: "Umrah/Hajj on behalf of a deceased family member.",
    href: WA_BADAL,
    external: true,
    cta_id: "Konsultasi WA",
    cta_en: "Ask via WA",
  },
];

export default function CategoriesSection() {
  const { lang, t } = useLang();
  return (
    <section className="py-24 lg:py-32 bg-muted/30" data-testid="categories-section">
      <div className="container-x">
        <header className="text-center max-w-2xl mx-auto mb-14">
          <div className="flex items-center justify-center gap-4 mb-4">
            <span className="h-px w-10 bg-accent" />
            <p className="overline">{t("categories.overline")}</p>
            <span className="h-px w-10 bg-accent" />
          </div>
          <h2 className="font-serif text-4xl lg:text-5xl text-primary tracking-tight">{t("categories.title")}</h2>
          <p className="mt-5 text-muted-foreground text-lg">{t("categories.sub")}</p>
        </header>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5 lg:gap-6">
          {CATEGORIES.map(({ key, Icon, color, id, en, desc_id, desc_en, href, external, cta_id, cta_en }, i) => {
            const Wrapper = external ? "a" : Link;
            const props = external
              ? { href, target: "_blank", rel: "noopener noreferrer" }
              : { to: href };
            return (
              <Wrapper
                key={key}
                {...props}
                data-testid={`category-card-${key}`}
                className="group bg-card border border-border rounded-2xl p-7 lg:p-8 flex flex-col hover:shadow-xl hover:-translate-y-1 hover:border-accent transition-all duration-300 anim-fade-up"
                style={{ animationDelay: `${i * 80}ms` }}
              >
                <div className={`w-14 h-14 rounded-2xl flex items-center justify-center mb-5 ${color} group-hover:scale-110 transition-transform duration-300`}>
                  <Icon className="h-6 w-6" />
                </div>
                <h3 className="font-serif text-xl lg:text-2xl text-primary leading-tight mb-3">{lang === "id" ? id : en}</h3>
                <p className="text-sm text-muted-foreground leading-relaxed flex-1">{lang === "id" ? desc_id : desc_en}</p>
                <div className="mt-6 pt-4 border-t border-border">
                  <span className="inline-flex items-center gap-1.5 text-xs uppercase tracking-[0.18em] font-semibold text-accent group-hover:text-primary transition-colors">
                    {lang === "id" ? cta_id : cta_en}
                    <ArrowRight className="h-3.5 w-3.5 group-hover:translate-x-1 transition-transform" />
                  </span>
                </div>
              </Wrapper>
            );
          })}
        </div>
      </div>
    </section>
  );
}
